<template>
  <div class="vertical-nav bg-main py-3 px-2 d-flex" id="sidebar">
    <!-- Head -->
    <div class="head">
      <div class="p-0 main_name d-flex justify-content-center">
        <router-link class="nav-link text-nowrap" to="/companies">
          {{ $t("titles.companyName") }}
        </router-link>
      </div>
      <div class="p-0 mt-3" v-if="!showAdmin">
        <SelectInstitution class="" />
      </div>
    </div>

    <!-- Content APP -->
    <div class="nav_content mt-4" v-if="!showAdmin">
      <div class="nav_item mt-3">
        <router-link v-if="$store.getters.institutions && $store.getters.institutions.length !== 0"
          class="nav-link text-nowrap" to="/companies" @click="toggleMobileShow">
          <icon icon="Search" class="search_icon"></icon>
          <span class="nav_text" :class="{ 'active': isCurrentRoute('/companies') }">{{ $t("navbar.search") }}</span>
        </router-link>
        <router-link v-else class="nav-link text-nowrap" to="/institution/none" @click="toggleMobileShow">
          <icon icon="Search" class="search_icon"></icon>
          <span class="nav_text" :class="{ 'active': isCurrentRoute('/companies') }">{{ $t("navbar.search") }}</span>
        </router-link>
      </div>
      <div class="nav_item mt-3" :class="{ 'active': isCurrentRoute('/profile') }">
        <router-link class="nav-link text-nowrap" to="/profile" @click="toggleMobileShow">
          <icon icon="User" class="user_icon"></icon>
          <span class="nav_text" :class="{ 'active': isCurrentRoute('/profile') }">{{ $t("navbar.myProfile") }}</span>
        </router-link>
      </div>
      <div v-if="$store.getters.isAdmin" class="nav_item mt-3"
        :class="{ 'active': isCurrentRoute('/institution/' + institutionId) }">
        <router-link :to="'/institution/' + institutionId" class="nav-link text-nowrap" @click="toggleMobileShow">
          <icon icon="Users" class="users_icon"></icon>
          <span class="nav_text" :class="{ 'active': isCurrentRoute('/institution/' + institutionId) }">{{
            $t("navbar.institution") }}</span>
        </router-link>
      </div>
      <div class="nav_item mt-3" :class="{ 'active': isCurrentRoute('/calendar') }">
        <router-link class="nav-link tex-nowrap" to="/calendar" @click="toggleMobileShow">
          <icon icon="CalendarNav"></icon>
          <span class="nav_text" :class="{ 'active': isCurrentRoute('/calendar') }">{{ $t("navbar.calendar") }}</span>
        </router-link>
      </div>
      <div class="nav_item mt-3" :class="{ 'active': isCurrentRoute('/contacts') }">
        <router-link class="nav-link tex-nowrap" to="/contacts" @click="toggleMobileShow">
          <icon icon="Contacts"></icon>
          <span class="nav_text" :class="{ 'active': isCurrentRoute('/contacts') }">{{ $t("navbar.contacts") }}</span>
        </router-link>
      </div>
      <div v-if="showExports()" class="nav_item mt-3"
        :class="{ 'active': isCurrentRoute('/institution' + institutionId + '/exports') }">
        <router-link class="nav-link tex-nowrap" :to="'/institution/' + institutionId + '/exports'"
          @click="toggleMobileShow">
          <icon icon="Exports"></icon>
          <span class="nav_text" :class="{ 'active': isCurrentRoute('/institution' + institutionId + '/exports') }">{{
            $t("navbar.exports") }}</span>
        </router-link>
      </div>
    </div>

    <!-- Content Admin -->
    <div class="nav_content mt-4" v-if="showAdmin">
      <div class="nav_item mt-3">
        <router-link class="nav-link text-nowrap" to="/companies" @click="toggleMobileShow">
          <icon icon="Info" class="search_icon"></icon>
          <span class="nav_text">{{ $t("navbar.toApp") }}</span>
        </router-link>
      </div>
      <div class="nav_item mt-3">
        <router-link class="nav-link text-nowrap" to="/admin" @click="toggleMobileShow">
          <icon icon="Search" class="search_icon"></icon>
          <span class="nav_text" :class="{ 'active': isCurrentRoute('/admin') }">{{ $t("navbar.institutionSearch")
            }}</span>
        </router-link>
      </div>
      <div class="nav_item mt-3">
        <router-link class="nav-link text-nowrap" to="/admin/general-stats" @click="toggleMobileShow">
          <icon icon="Chart" class=""></icon>
          <span class="nav_text" :class="{ 'active': isCurrentRoute('/admin/general-stats') }">{{
            $t("navbar.generalStats") }}</span>
        </router-link>
      </div>
      <div class="nav_item mt-3">
        <router-link class="nav-link text-nowrap" to="/admin/sales-stats" @click="toggleMobileShow">
          <icon icon="Chart" class=""></icon>
          <span class="nav_text" :class="{ 'active': isCurrentRoute('/admin/sales-stats') }">{{ $t("navbar.salesStats")
            }}</span>
        </router-link>
      </div>
      <div class="nav_item mt-3" :class="{ 'active': isCurrentRoute('/admin/institution/add') }">
        <router-link class="nav-link text-nowrap" to="/admin/institution/add" @click="toggleMobileShow">
          <icon icon="Plus" class="user_icon"></icon>
          <span class="nav_text" :class="{ 'active': isCurrentRoute('/admin/institution/add') }">{{
            $t("navbar.institutionAdd") }}</span>
        </router-link>
      </div>
      <div class="nav_item mt-3" :class="{ 'active': isCurrentRoute('/mcp-tokens') }">
        <router-link class="nav-link text-nowrap" to="/mcp-tokens" @click="toggleMobileShow">
          <icon icon="Settings"></icon>
          <span class="nav_text" :class="{ 'active': isCurrentRoute('/mcp-tokens') }">{{ $t("navbar.mcpTokens")
            }}</span>
        </router-link>
      </div>
    </div>

    <!-- Lower content -->
    <div class="flex-grow-1"></div> <!-- Add flex-grow-1 class -->
    <div class="lower_content text-start">
      <div class="mb-4 logout text-center">
        <router-link class="nav-link text-nowrap d-flex align-items-center justify-content-center" to="/logout">
          <icon icon="Logout" class="logout_icon pe-2"></icon>
          <span>{{ $t("navbar.logout") }}</span>
        </router-link>
      </div>
      <div class="version_row d-flex align-items-center justify-content-center">
        <button type="button" class="version_chip" @click="showChangelog()">
          <icon icon="Info" class="version_icon" />
          <span>{{ $t("utils.version") }} {{ $store.getters.version }}</span>
        </button>
      </div>
    </div>

    <div class="toggle mt-4">
      <button class="btn btn_close close" @click="toggleMobileShow">Zavřít</button>
    </div>
  </div>

</template>

<script>
import SelectInstitution from "@/components/SelectInstitution.vue"
import Icon from '@/components/Icon.vue';
import ShowUpdates from "@/components/ShowUpdates.vue";

export default {
  components: {
    SelectInstitution,
    Icon,
    ShowUpdates
  },
  data() {
    return {
      institutionId: null,
      mobileShow: false,
    }
  },
  created() {
    // Get institution id from store
    this.institutionId = this.$store.getters.selectedInstitution;
  },
  computed: {
    user: function () {
      return this.$store.getters.user
    },
    showAdmin: function () {
      if (this.$route.meta.admin != null) {
        return this.$route.meta.admin === true;;
      }
      return false;
    },
  },
  methods: {
    // Sidebar toggle behavior
    toggleMobileShow() {
      this.mobileShow = false
      this.$emit('update-mobile-show', this.mobileShow);
    },
    isCurrentRoute(route) {
      return this.$route.path === route;
    },
    showChangelog() {
      this.$store.getters.user.seen_updates = false
    },
    showExports() {
      // Decide if institution has any exports
      if (this.institutionId) {
        const institution = this.$store.getters.user.institutions.find(
          (institution) => institution.id === this.institutionId
        )
        if (institution && institution.has_exports) {
          return true
        } else {
          return false
        }
      }
    }

  }
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.vertical-nav {
  min-height: 100vh;
  width: 260px;
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: $shadow-md;
  transition: all 0.4s;
  background: $gradient-panel;
  color: $white;
  // Override bootstrap `.navbar { align-items: center }`, which (in a flex
  // column) squeezes the nav content into a narrow centered strip. Stretching
  // lets nav buttons span the full width (close to the edges).
  align-items: stretch;

  .main_name {
    color: $white;
    font-family: $font-display;
    font-weight: 800;
    font-size: clamp(28px, 3.2vw, 40px);
    letter-spacing: 0.5px;
    font-style: normal;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);
  }

  .nav_link {
    font-size: 20px;
    text-decoration: none;
    font-weight: 400;
    display: flex;
    align-items: center;
  }


  .nav_text {
    display: inline-block;
  }

  .nav_item {
    font-size: 18px;
    text-decoration: none;

    .nav-link {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 8px 14px;
      border-radius: $radius-md;
      font-size: 18px;
      font-weight: 400;
      letter-spacing: 0.5px;
      text-decoration: none;
      position: relative;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: rgba($white, 0.12);
      }

      // Active route — filled highlight + left accent bar.
      &:has(.nav_text.active) {
        background-color: rgba($white, 0.18);
        font-weight: 600;

        &::before {
          content: '';
          position: absolute;
          left: 4px;
          top: 20%;
          bottom: 20%;
          width: 3px;
          border-radius: $radius-pill;
          background-color: $white;
        }
      }
    }

    svg {
      width: 42px;
      height: 42px;
      border-radius: $radius-md;
      padding: 7px;
      stroke: $white;
      background-color: transparent;
      flex: 0 0 auto;
    }
  }

  .close {
    padding: 9px 25px;
    font-size: 16px;
    font-weight: 600;
    background-color: $grey;
    border-radius: $radius-md;
    color: $black;
  }

  .show_changelog:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

.logout {
  background-color: $dark-purple;
  border-radius: $radius-md;
  padding: 9px 16px;
  box-shadow: $shadow-sm;
  letter-spacing: 0.3px;
  font-size: 16px;
  text-decoration: none;

  svg {
    width: 30px;
    height: 30px;
    border-radius: $radius-sm;
    padding: 4px;
    stroke: $white;
    background-color: transparent;
    display: inline-block;
  }
}

.logout:hover {
  background-color: $black-purple;
}

// App-version chip — clearly a button that opens the changelog.
.version_chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba($white, 0.10);
  border: 1px solid rgba($white, 0.22);
  color: rgba($white, 0.9);
  border-radius: $radius-pill;
  padding: 5px 14px;
  font-size: 13px;
  letter-spacing: 0.2px;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;

  .version_icon {
    width: 15px;
    height: 15px;
    padding: 0;
    border-radius: 0;
    stroke: $white;
    flex: 0 0 auto;
  }

  &:hover {
    background: rgba($white, 0.18);
    border-color: rgba($white, 0.4);
  }
}

/* for toggle behavior */

#sidebar.active {
  margin-left: -17rem;
}

#content.active {
  width: 100%;
  margin: 0;
}

@media (min-width: 1400px) and (max-width: 1700px) {
  .navbar {
    margin-right: 0px;
  }
}

@media (max-width: 991px) {
  .toggle {
    display: block;
  }

  .vertical-nav {
    width: 100%;
    left: 0;
    transform: none;
    margin: 0;
    padding: 24px 20px;

    // Center the drawer content in a comfortable column instead of a thin strip.
    .head,
    .nav_content,
    .lower_content,
    .toggle {
      width: 100%;
      max-width: 460px;
      margin-left: auto;
      margin-right: auto;
    }

    .main_name {
      font-size: 38px;
    }

    // Bigger, touch-friendly nav rows on phones/tablets.
    .nav_item .nav-link {
      font-size: 19px;
      padding: 13px 16px;
    }

    .toggle {
      text-align: center;
    }
  }

  #sidebar.active {
    margin-left: 0;
  }

  #content {
    width: 100%;
    margin: 0;
  }

  #content.active {
    margin-left: 17rem;
    width: calc(100% - 17rem);
  }
}

@media (min-width: 992px) {
  .toggle {
    display: none;
  }
}

@media (min-width: 100px) and (max-height: 868px) {
  .vertical-nav {
    display: flex;
    overflow-y: auto;
    overflow-x: hidden;
  }
}

@media (min-height: 750px) {
  .vertical-nav {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>